<template>
  <div class="video">
    <iframe
      class="iframe h-full w-full"
      allowfullscreen
      :src="`https://www.youtube.com/embed/${post.video}?rel=0`"
    />
  </div>
</template>

<script>
export default {
  name: 'Video',

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
/* .video {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}

.iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
} */
</style>
